import { DCUIContent } from "@iddataweb/idw-common-ui/types";
import { resources } from "@constants/hardcoded-strings";
import { TabTitleWithErrorCount } from "@containers/common/tab-title-with-error-count/tab-title-with-error-count";
import { ErrorAlert } from "@containers/common/error-alert/error-alert";
import { DCUIThemingCaptureCompleteValidationErrors } from "@idw-types/common/validation/common/dcui-theming-validation-errors";

export const getDCUIThemingCaptureCompleteValidationErrors = (
    isUsingDCUIVersion2: boolean,
    hasDisplayableDocumentCaptureAttributes: boolean,
    dcuiContent: DCUIContent
): DCUIThemingCaptureCompleteValidationErrors => {
    let count = 0;
    let uploadCompleteTitleError = null;
    let uploadInProgressTitleError = null;
    let uploadSuccessMessageWithRedirectError = null;
    let uploadSuccessMessageWithoutRedirectError = null;
    let uploadErrorMessageError = null;

    if (isUsingDCUIVersion2 && hasDisplayableDocumentCaptureAttributes) {
        if (!dcuiContent.captureComplete.captureUploadCompleteTitle) {
            count += 1;
            uploadCompleteTitleError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert >;
        }
        if (!dcuiContent.captureComplete.captureUploadTitle) {
            count += 1;
            uploadInProgressTitleError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert >;
        }
        if (!dcuiContent.captureComplete.captureSuccessMessage) {
            count += 1;
            uploadSuccessMessageWithRedirectError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert >;
        }
        if (!dcuiContent.captureComplete.captureSuccessNoRedirectMessage) {
            count += 1;
            uploadSuccessMessageWithoutRedirectError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert >;
        }
        if (!dcuiContent.captureComplete.captureUploadErrorMessage) {
            count += 1;
            uploadErrorMessageError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert >;
        }
    }

    return {
        uploadCompleteTitleError,
        uploadInProgressTitleError,
        uploadSuccessMessageWithRedirectError,
        uploadSuccessMessageWithoutRedirectError,
        uploadErrorMessageError,
        count: count,
        tabTitle: <TabTitleWithErrorCount
            tabName={resources.pages.verificationServiceDetails.tabs.dcuiTheming.subTabs.captureComplete.tabName}
            errorCount={count}
        />
    };
};